import { render, staticRenderFns } from "./ViewJsonFile.vue?vue&type=template&id=3bde31b2&scoped=true&"
import script from "./ViewJsonFile.vue?vue&type=script&lang=js&"
export * from "./ViewJsonFile.vue?vue&type=script&lang=js&"
import style0 from "./ViewJsonFile.vue?vue&type=style&index=0&id=3bde31b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bde31b2",
  null
  
)

export default component.exports